import axios, { AxiosResponse } from 'axios';
import {
	IOutreachConnectPayload,
	IIntercomConnectPayload,
	IGongConnectPayload,
	IZendeskConnectPayload,
} from './types';

export const getApplications = (): Promise<AxiosResponse> =>
	axios.get(`/applications`);

export const disconnectApplication = (appId: string): Promise<AxiosResponse> =>
	axios.post(`/applications/disconnect`, { appId });

export const connectOutreach = (
	payload: IOutreachConnectPayload
): Promise<AxiosResponse> => axios.post(`/outreach/connect`, payload);

export const connectIntercom = (
	payload: IIntercomConnectPayload
): Promise<AxiosResponse> => axios.post(`/intercom/connect`, payload);

export const connectGong = (
	payload: IGongConnectPayload
): Promise<AxiosResponse> => axios.post(`/gong/connect`, payload);

export const connectZendesk = (
	payload: IZendeskConnectPayload
): Promise<AxiosResponse> => axios.post(`/zendesk/connect`, payload);

export const sendCodeOutreach = (code: string): Promise<AxiosResponse> =>
	axios.post(`/outreach/callback`, { code });
